import { render, staticRenderFns } from "./HolidayGrid.vue?vue&type=template&id=bd3ff04c"
import script from "./HolidayGrid.vue?vue&type=script&lang=js"
export * from "./HolidayGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports